import { SearchIcon } from 'assets/icons';
import { debounce } from 'lodash';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { InputField, SelectField } from 'components/FormFields';
import { useLineCategoryList } from 'hooks';
import { InitAllowanceFilters } from 'types';

interface AllowanceFiltersProps {
  initialValues: Partial<InitAllowanceFilters>;
  onSubmit?: (payload: InitAllowanceFilters) => void;
}

export function AllowanceFilters({ initialValues, onSubmit }: AllowanceFiltersProps) {
  const { t } = useTranslation(['action', 'payroll']);

  const { data: lineCategoryList, isLoading } = useLineCategoryList();
  const lineCategoryOptions = lineCategoryList.map((x) => ({
    label: x.name,
    value: x.projectCode,
  }));

  const { control, handleSubmit } = useForm<InitAllowanceFilters>({
    defaultValues: {
      ...initialValues,
      search: '',
    },
  });

  const handleFiltersSubmit = (formValues: InitAllowanceFilters) => {
    onSubmit?.(formValues);
  };

  const debounceSearchChange = debounce(handleSubmit(handleFiltersSubmit), 350);

  return (
    <StyledForm onSubmit={handleSubmit(handleFiltersSubmit)}>
      <StyledContainer>
        <InputField
          name="search"
          control={control}
          placeholder={t('action:search')}
          prefix={<SearchIcon />}
          onChange={() => debounceSearchChange()}
        />

        <StyledSearchField>
          <SelectField
            name="line"
            placeholder={t('payroll:contract_salary.line_category_placeholder')}
            control={control}
            options={lineCategoryOptions}
            showSearch
            allowClear
            loading={isLoading}
            onChange={handleSubmit(handleFiltersSubmit)}
          />
        </StyledSearchField>
      </StyledContainer>
    </StyledForm>
  );
}

const StyledForm = styled.form`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
const StyledSearchField = styled.div`
  width: 200px;
`;
